import { defineStyleConfig } from '@chakra-ui/react'

import { inputTheme } from './input'

export const selectTheme = defineStyleConfig({
  baseStyle: {
    field: {
      // Reuse input base style. May need to merge in future.
      ...inputTheme.baseStyle?.field,
      cursor: 'pointer',
    },
    icon: {},
  },

  variants: {
    unstyled: {
      field: {
        border: 'none',
        paddingLeft: '0px', // TODO: resolve padding issue.
        paddingBottom: '0px !important', // TODO: resolve padding issue.
      },
      icon: {},
    },
  },
})
